module.exports = __webpack_public_path__ + "img/dabiaoshuiliang.fb1bc0f1.svg";